import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
} from "reactstrap";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import Spinners from "components/Common/Spinner";
import * as url from "../../helpers/url_helper";
import "flatpickr/dist/themes/material_blue.css";
import { MDBDataTable } from "mdbreact";
import { Link } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";

const EventList = (props) => {
  document.title = "Event List - VUF";

  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Event List", link: "#" },
  ];
  const [isLoading, setLoading] = useState(false);
  const [eventList, setEventList] = useState([]);
  const state = {
    isLoading: false,
    errors: {},
    ResErrors: {},
    isRedirect: false,
    sangathanId: null,
    country_code: "+91",
    ccode: "+91",
    email: "",
    mobileNo: "",
    remark: "",
    assignRole: "",
    firstName: "",
    lastName: "",
    country: "",
    state: "",
    city: "",
    RegistrationLinkToCopy: url.CurrentUrl + "EventRegister/",
    EventAttendantLinkToCopy: url.CurrentUrl + "EventAttendant/",
    QRCodeValue: "ABCD12345",
    locations: [],
    counts: {
      totalUsers: 0,
      mainApp: 0,
      gbnApp: 0,
      sangathanApp: 0,
      eventUsers: 0,
      locationUsers: 0,
    },
    selectionRange: {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },

    showDatePicker: false,
  };

  useEffect(() => {
    props.setBreadcrumbItems("Event List", breadcrumbItems);
  });

  useEffect(() => {
    EventList();
  }, []);

  function EventList() {
    setLoading(true);
    let urlPath = "event/get-all-event/";

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        setLoading(false);
        if (responseData.status) {
          setEventList(responseData.data);
        } else {
          toast.error("Something went wrong, Please try again after sometime.");
        }
      })
      .catch((error) => {
        console.log("err", error);
        toast.error("Something went wrong, Please try again after sometime.");
      })
      .finally((final) => {
        setLoading(false);
      });
  }

  function handleDeleteClick(e, event) {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this event?",
    );
    if (confirmDelete) {
      state.deleteItemId = event._id;
      onCheckDelete(e, event._id);

      console.log("Item deleted.");
    } else {
      console.log("Deletion canceled.");
    }
  }

  function onCheckDelete(e, event) {
    e.preventDefault();

    setLoading(true);
    state.itemDeleteLoading = true;

    let urlPath = "event/DeleteEvent/" + event;

    // this.setState({ loading: false });
    // return

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status) {
          toast.success("Event Removed Successfully.");
        } else if (!responseData.status && responseData.error) {
          toast.error(responseData?.error || "Error");
        } else {
          toast.error("Something went wrong, Please try again after sometime.");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("err", error);
        toast.error("Something went wrong, Please try again after sometime.");
      })
      .finally((final) => {});
  }

  const formattedEventList = eventList.map((event) => ({
    ...event,
    registrationStartDate: [
      moment(event.registrationStartDate).format("DD MMM YYYY"),
      <br />,
      " to ",
      <br />,
      moment(event.registrationEndDate).format("DD MMM YYYY"),
    ], // format as you wish
    eventStartDate: [
      moment(event.eventStartDate).format("DD MMM YYYY"),
      <br />,
      " to ",
      <br />,
      moment(event.eventEndDate).format("DD MMM YYYY"),
    ],
    city:
      event.city != undefined
        ? [event.city, ",", <br />, event.state, ",", <br />, event.country]
        : "",
    RegLink: [
      <a
        data-toggle="tooltip"
        title="Copy Registration Link"
        className="btn btn-warning btn-sm copylink "
        onClick={() => {
          navigator.clipboard.writeText(
            state.RegistrationLinkToCopy + `${event._id}`,
          );
        }}
      >
        <span className=" menu-icon fas fa fa-clone"></span>
      </a>,
    ],
    EventLink: [
      <a
        data-toggle="tooltip"
        title="Copy Event Attendant Link"
        className="btn btn-warning btn-sm copylink"
        onClick={() => {
          navigator.clipboard.writeText(
            state.EventAttendantLinkToCopy + `${event._id}`,
          );
        }}
      >
        <span className=" menu-icon fas fa fa-clone"></span>{" "}
      </a>,
    ],
    Action: [
      <Link
        to={`/EventDetails/${event._id}`}
        className="btn btn-info btn-sm m-1 "
      >
        <span className="menu-text" style={{ color: "white" }}>
          <span
            className=" menu-icon fas fa fa-eye"
            style={{ color: "white" }}
          ></span>
        </span>
      </Link>,
      <Link to={`/Event/${event._id}`} className="btn btn-warning btn-sm m-1 ">
        <span className="menu-text" style={{ color: "white" }}>
          <span
            className=" menu-icon fas fa fa-pen"
            style={{ color: "white" }}
          ></span>
        </span>
      </Link>,
      <Link
        to={`/Event/${event._id}/EventCategoryList`}
        className="btn btn-primary btn-sm m-1 "
      >
        <span className="menu-text" style={{ color: "white" }}>
          <span
            className=" menu-icon fas fa fa-list"
            style={{ color: "white" }}
          ></span>
        </span>
      </Link>,
      <button
        type="button"
        className="btn btn-danger btn-sm  m-1"
        onClick={(e) => {
          handleDeleteClick(e, event);
        }}
      >
        <span
          className=" menu-icon fas fa fa-trash"
          style={{ color: "white" }}
        ></span>
      </button>,
    ],
  }));
  const tableData = {
    columns: [
      {
        label: "Event Name",
        field: "eventName",
        sort: "asc",
        width: 23,
      },
      {
        label: "Reg. Date",
        width: 13,
        sort: "asc",
        field: "registrationStartDate", //[moment(registrationStartDate).format("DD MMM YYYY"), <br />, " to ", <br />, moment(registrationEndDate).format("DD MMM YYYY")]
      },
      {
        label: "Event Date",
        width: 13,
        sort: "asc",
        field: "eventStartDate",
      },
      {
        label: "Location",
        width: 13,
        sort: "asc",
        field: "city",
      },
      {
        label: "Reg. Link",
        width: 10,
        sort: "asc",
        field: "RegLink",
      },
      {
        label: "Attnd. Link",
        width: 10,
        sort: "asc",
        field: "EventLink",
      },
      {
        label: "Action",
        width: 18,
        sort: "asc",
        field: "Action",
      },
    ],
    rows: formattedEventList,
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <div className="row align-items-center">
                  <div className="col d-flex justify-content-between align-items-center">
                    <CardTitle className="h4 mb-0">Event List</CardTitle>
                    <Link
                      to="/Event"
                      className="btn btn-outline-primary h5 mb-0"
                    >
                      <span className="menu-text">
                        <i className="fa fa-plus me-2"></i>
                        Add Event
                      </span>
                    </Link>
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <br />
                <div class="row">
                  <MDBDataTable responsive striped bordered data={tableData} />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(EventList);
